import * as React from "react";
const SvgCopy = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" {...props}><path d="M0 0h24v24H0z" data-name="Trazado 514" style={{
    fill: "none"
  }} /><path d="M16 1H4a2.006 2.006 0 0 0-2 2v14h2V3h12zm-1 4H8a2 2 0 0 0-1.99 2L6 21a2 2 0 0 0 1.99 2H19a2.006 2.006 0 0 0 2-2V11zM8 21V7h6v5h5v9z" data-name="Trazado 515" /></svg>;
export { SvgCopy as ReactComponent };